export default (siteName) => [
    {
        path: 'reimbursement-invoice',
        name: 'reimbursement-invoice',
        component: () => import('../../components/dashboard/Finance/ReimbursementInvoice/indexPage.vue'),
        meta: {
            title: `核銷轉開發票${siteName}`,
            activeMenu: 'finance',
        },
    },
    {
        path: 'reimbursement-invoice/add/',
        name: 'reimbursement-invoice-add',
        component: () => import('../../components/dashboard/Finance/ReimbursementInvoice/EditPage.vue'),
        meta: {
            title: `新增核銷轉開發票${siteName}`,
            activeMenu: 'finance',
        },
    },
    {
        path: 'reimbursement-invoice/:tioo/edit/',
        name: 'reimbursement-invoice-edit',
        component: () => import('../../components/dashboard/Finance/ReimbursementInvoice/EditPage.vue'),
        meta: {
            title: `編輯核銷轉開發票${siteName}`,
            activeMenu: 'finance',
        },
    },
];
